function Footer() {
  return (
    <footer>
        <p>© 2026 GMED. Todos os direitos reservados.</p>
    </footer>
  );
}

export default Footer;
